import _applyDecoratedDescriptor from "@babel/runtime-corejs3/helpers/applyDecoratedDescriptor";
var _class;
import { action, computed, observable } from 'mobx';
export let ShoppingDiscounts = (_class = class ShoppingDiscounts {
  constructor(initialDiscounts) {
    this.state = void 0;
    this.state = observable({
      attempts: initialDiscounts !== null && initialDiscounts !== void 0 ? initialDiscounts : observable.array()
    });
  }
  get attempts() {
    return this.state.attempts;
  }
  get latest() {
    return this.state.attempts[0];
  }
  get codes() {
    return this.state.attempts.map(attempt => attempt.code);
  }
  get invalidCodes() {
    return this.getCodesByStatus('invalid');
  }
  get expiredCodes() {
    return this.getCodesByStatus('expired');
  }
  get soldOutCodes() {
    return this.getCodesByStatus('sold_out');
  }
  clear() {
    this.state.attempts.clear();
  }
  getCodesByStatus(status) {
    return this.state.attempts.filter(attempt => attempt.status == status).map(attempt => attempt.code);
  }
}, (_applyDecoratedDescriptor(_class.prototype, "attempts", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "attempts"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "latest", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "latest"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "codes", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "codes"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "invalidCodes", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "invalidCodes"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "expiredCodes", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "expiredCodes"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "soldOutCodes", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "soldOutCodes"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "clear", [action], Object.getOwnPropertyDescriptor(_class.prototype, "clear"), _class.prototype)), _class);
//# sourceMappingURL=shopping-discounts.js.map